import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const createSurvey = async (data) => {
  const response = await apiClient.request('POST', '/admin/surveys', data);
  if (!isApiResponseError(response)) {
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw {
      ...validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE),
      field_names: response?.error?.field_names || [],
    };
  }
};

export const updateSurvey = async (id, data) => {
  const response = await apiClient.request('PUT', `/admin/surveys/${id}`, data);
  if (!isApiResponseError(response)) {
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw {
      ...validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE),
      status_code: response.status,
      field_names: response?.error?.field_names || [],
    };
  }
};

export const surveyDetail = async (id) => {
  const response = await apiClient.request('GET', `/admin/surveys/${id}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const surveys = async (query) => {
  const response = await apiClient.request('GET', `/admin/surveys${query}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name surveysDeleteById
 * @param {string | number} id
 * @response success - 204 No Content
 * @response failure - 404 Not Found
 */
export const surveysDeleteById = async (id) => {
  const response = await apiClient.request('DELETE', `/admin/surveys/${id}`);
  if (!isApiResponseError(response)) {
    return true;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name surveysDeleteByIds
 * @param {Array.<string | number>} ids
 * @response success - 204 No Content
 * @response failure - 404 Not Found
 */
export const surveysDeleteByIds = async (ids) => {
  const response = await apiClient.request('DELETE', '/admin/surveys', ids);
  if (!isApiResponseError(response)) {
    return true;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const surveyMakeDuplicate = async (id, data) => {
  const response = await apiClient.request('POST', `/admin/surveys/${id}/make-duplicate`, data);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const surveyMakePrivate = async (id) => {
  const response = await apiClient.request('GET', `/admin/surveys/${id}/make-private`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const surveyExport = async (data, export_type) => {
  const response = await apiClient.request('POST', `/admin/surveys/export?export_type=${export_type}`, data, {
    responseType: 'blob',
  });
  if (!isApiResponseError(response)) {
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'survey_export.zip';
    if (contentDisposition) {
      /* eslint-disable */
      const utf8Match = contentDisposition.split("filename*=utf-8''");
      if (utf8Match.length > 1) {
        filename = decodeURIComponent(utf8Match[1]);
      } else {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch !== null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }
      /* eslint-enable */
    }

    const blob = response?.data;
    const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const surveyPublicPeriodSetting = async (data, id) => {
  const response = await apiClient.request('POST', `/admin/surveys/${id}/make-public-scheduled`, data);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const makePublicScheduled = async (id, data) => {
  const response = await apiClient.request('POST', `/admin/surveys/${id}/make-public-scheduled`, data);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const cancelPublicScheduled = async (id) => {
  const response = await apiClient.request('GET', `/admin/surveys/${id}/cancel-public-scheduled`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
